import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { TableFooter, TableRow, TableCell, RaiseColors, makeStyles } from "componentLibrary";
import { stickyColumnShadowStyles, STICKY_COLUMN_Z_INDEX } from "../stickyColumnStyles";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    footerContainer: {
      boxShadow: "0px -5px 11px 0px ".concat(RaiseColors.midnight, "14"),
      background: "white",
      position: "sticky",
      bottom: 0,
      borderRadius: "16px"
    },
    row: {
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px"
    },
    cell: {
      borderStyle: "none",
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px"
    },
    stickyCell: _objectSpread({
      position: "relative",
      borderStyle: "none",
      borderBottomLeftRadius: "16px"
    }, stickyColumnShadowStyles),
    stickyCellPositioned: {
      position: "sticky",
      left: 0,
      zIndex: STICKY_COLUMN_Z_INDEX,
      borderBottomLeftRadius: "16px",
      borderStyle: "none"
    },
    stickyCellPositionedWithShadow: _objectSpread({
      position: "sticky",
      left: 0,
      zIndex: STICKY_COLUMN_Z_INDEX,
      borderBottomLeftRadius: "16px",
      borderStyle: "none"
    }, stickyColumnShadowStyles)
  };
});
var FooterRow = function FooterRow(_ref) {
  var headers = _ref.headers,
    footerData = _ref.footerData,
    _ref$stickyFirstColum = _ref.stickyFirstColumn,
    stickyFirstColumn = _ref$stickyFirstColum === void 0 ? false : _ref$stickyFirstColum,
    borderRadius = _ref.borderRadius,
    _ref$showStickyColumn = _ref.showStickyColumnShadow,
    showStickyColumnShadow = _ref$showStickyColumn === void 0 ? false : _ref$showStickyColumn;
  var classes = useStyles();
  return /*#__PURE__*/_jsx(TableFooter, {
    className: classes.footerContainer,
    children: /*#__PURE__*/_jsx(TableRow, {
      className: classes.row,
      children: headers === null || headers === void 0 ? void 0 : _mapInstanceProperty(headers).call(headers, function (header, cellIndex) {
        var _header$renderFooterC;
        var isStickyFirstColumn = cellIndex === 0 && stickyFirstColumn;
        var cellClassName = isStickyFirstColumn ? showStickyColumnShadow ? classes.stickyCellPositionedWithShadow : classes.stickyCellPositioned : classes.cell;
        return /*#__PURE__*/_jsx(React.Fragment, {
          children: header.renderFooterCell ? /*#__PURE__*/_jsx(TableCell, {
            className: cellClassName,
            children: (_header$renderFooterC = header.renderFooterCell) === null || _header$renderFooterC === void 0 ? void 0 : _header$renderFooterC.call(header, {
              footerData: footerData
            })
          }) : /*#__PURE__*/_jsx(TableCell, {
            className: cellClassName
          })
        }, cellIndex);
      })
    })
  });
};
export default FooterRow;